module.exports = __webpack_public_path__ + "img/logo_title.4e92466d.png";